import Cookie from 'js-cookie'
import queryString from '@/utils/queryString'
// 微信登录授权
function loginByWX () {
  let wkAppId = queryString().appId || window.localStorage.getItem('wkAppId')
  let serveParams = ''
  console.log(window.localStorage.getItem('wkAppId'), queryString().appId)
  if (wkAppId == 'wx84a3a43143e5d0bc') {
      serveParams = `&component_appid=wx6d2973819f4d7c88`
  }
  const _url = `http://service.auoktalk.com/task/pocketyuedu/auth?redirect=${encodeURIComponent(window.location.href)}&appId=${wkAppId}${serveParams}`
  const redirectURL = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wkAppId}&redirect_uri=${encodeURIComponent(_url)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect${serveParams}`
  window.location.href = redirectURL
}

async function getWpsSid () {
  return Cookie.get('openid')
}


async function login (callback = function () { window.location.reload() }) {
  const userId = await getWpsSid()
  if (userId) return
  loginByWX()
  // 测试openId
  // Cookie.set('openid', 'oDWg_6jWy_u2B4uSRjTZ2CK1FzSU', '.*')
}
export default {
  login,
  loginByWX,
  getWpsSid
}
